import { useEffect, useContext, PropsWithChildren } from 'react';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import { TrackingContext } from '@elementary/common-ui/providers/tracking';
import { useAuth } from '@frontegg/react';
import { useLocation } from 'react-router-dom';
import useEnvironments from 'shared/hooks/useEnvironments';

const PosthogProvider = ({ children }: PropsWithChildren) => {
  const { user } = useAuth();

  const { data: accountData } = useAccount();

  const { pathname: currentPathname } = useLocation();
  const { selectedEnv } = useEnvironments();
  const env = import.meta.env.mode;

  const tracking = useContext(TrackingContext);

  useEffect(() => {
    tracking?.sendTrackingEvent({
      eventName: tracking.analytics.events.NAVIGATION,
      properties: { path: currentPathname },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPathname]);

  useEffect(() => {
    const registerParams = {
      env,
      user_id: user?.id,
      user_name: user?.name,
      user_email: user?.email,
      account_id: accountData?.id || user?.tenantId,
      account_name: accountData?.name,
      account_activation_status: accountData?.activation_status,
      environment_id: selectedEnv?.id,
      environment_name: selectedEnv?.name,
      warehouse_type: selectedEnv?.dwhConnection.warehouseType,
    };
    const userIdentifier = user?.id;
    const userParams = {
      name: user?.name,
      email: user?.email,
    };

    tracking?.initTracking({
      groupType: tracking.analytics.groups.ACCOUNT,
      groupKey: user?.tenantId ?? '',
      registerParams,
      userIdentifier,
      userParams,
      shouldRecord: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [env, user, selectedEnv, accountData, selectedEnv?.id]);

  return children;
};

export default PosthogProvider;
